const locks = new WeakMap()

// Multiple rows can upload concurrently; only the last completion unlocks saving.
export function lockFormDuringUpload(element) {
  const form = element.closest("form")
  if (!form) return () => {}

  let lock = locks.get(form)
  if (!lock) {
    const buttons = Array.from(form.querySelectorAll('[type="submit"]')).filter(button => !button.disabled)
    const preventSubmit = event => {
      event.preventDefault()
      event.stopImmediatePropagation()
    }
    lock = { count: 0, buttons, preventSubmit }
    locks.set(form, lock)
    buttons.forEach(button => { button.disabled = true })
    form.addEventListener("submit", preventSubmit, true)
  }
  lock.count += 1
  let released = false
  return () => {
    if (released) return
    released = true
    lock.count -= 1
    if (lock.count > 0) return
    lock.buttons.forEach(button => { button.disabled = false })
    form.removeEventListener("submit", lock.preventSubmit, true)
    locks.delete(form)
  }
}
